var render = function render(){var _vm=this,_c=_vm._self._c;return _c('http-patch-button',_vm._g(_vm._b({attrs:{"value":_vm.patches,"href":`/api/metadata/products/${(_vm.value || {}).productId}`},on:{"http4xx":_vm.onError}},'http-patch-button',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }